import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { connect } from "react-redux";
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { createStructuredSelector } from "reselect";
import fetchSelect from "../../effects/fetch-select";
import useFetchDefault from "../../effects/use-fetch-default";
import { setValueEntredBlur } from "../../redux/form/form.actions";
import { selectFormEdit } from "../../redux/form/form.reselect";
import FormFieldError from "../form-field-error/form-field-error.componenet";
import { selectFormTableLatestData } from "../../redux/form/form.reselect";
import './select-field.componenet.scss';
import { setModalShow, setModalTriggerName } from "../../redux/modal/modal.actions";
import CustomMenuList from "../custom-menu-list/custom-menu-list.component";

const SelectField = ({
    label,
    type,
    handleChange,
    initialFocus,
    onChange,
    required,
    fieldName,
    partNumber,
    fieldItemName,
    validationProps,
    authToken,
    endpointUrl,
    selectEdit,
    mutliselect,
    disabled,
    defaultValue,
    isDefaultValueFromApi,
    inverted,
    isNotArrayField,
    isSearchable,
    setValueEntredBlur,
    hasDefaultValue,
    defaultValueUrl,
    formEdit,
    createNew,
    noAvailability,
    formLatestData,
    isAccount,
    setModalShow,
    setModalTriggerName,
    ...otherProps
}) => {
    const [defaultValueFromApi, setDefaultValueFromApi] = useState("");

    const { defaultData, defaultError } = useFetchDefault(defaultValueUrl, authToken, hasDefaultValue);

    const customStyles = {
        // Kept visually identical to .form-field__input, since the two sit
        // side by side in the same form rows.
        control: (styles) => ({
            ...styles,
            fontFamily: 'var(--font-sans)',
            border: `1px solid ${disabled ? 'var(--color-border)' : 'var(--color-border-strong)'}`,
            height: !mutliselect ? '33.5px' : "",
            minHeight: 'var(--control-height)',
            backgroundColor: disabled ? 'var(--color-surface-subtle)' : inverted ? 'var(--color-surface-subtle)' : 'var(--color-surface)',
            color: disabled ? 'var(--color-text-secondary)' : 'var(--color-text)',
            textIndent: '0px',
            borderRadius: 'var(--radius-md)',
            fontSize: 'var(--font-size-base)',
            boxShadow: "none",
            textTransform: "capitalize",
            pointerEvents: "auto",
            "&:focus-within": {
                borderColor: "var(--color-primary)",
                boxShadow: "var(--focus-ring)"
            },
            "&:hover": {
                cursor: disabled ? "not-allowed" : "pointer"
            }
        }),
        option: (provided, state) => ({
            ...provided,
            fontSize: "var(--font-size-base)",
            backgroundColor: state.isSelected ? "var(--color-surface-sunken)" : "",
            color: state.isSelected ? "var(--color-text)" : null,
            borderRadius: "var(--radius-sm)",
            marginTop: "3px",
            textTransform: "capitalize",
            "&:hover": {
                backgroundColor: "var(--color-surface-sunken)",
            },
        }),
        singleValue: (provided, state) => {
            const opacity = state.isDisabled ? 0.7 : 1;
            const color = state.isDisabled ? '#000' : "";
            const transition = 'opacity 300ms';
            return {
                ...provided,
                opacity,
                transition,
                color,
            };
        },
        menuPortal: base => ({ ...base, zIndex: 9999 }),
        menu: (provided) => ({
            ...provided,
            position: 'relative',
            zIndex: 2,
        }),
        menuList: (provided) => ({
            ...provided,
            maxHeight: '350px', // Adjust the height as needed
            overflowY: 'auto',
        }),
    }

    const { control, register, formState: { errors }, setValue } = useFormContext();

    const name = isNotArrayField ? fieldName : fieldName + '.' + partNumber + '.' + fieldItemName;
    const nameSection = isNotArrayField ? fieldName : fieldName + '.' + partNumber

    const valueEntered = () => {
        setValueEntredBlur(true)
    }

    const loadOptions = (inputValue) => {
        return new Promise((resolve, reject) => {
            resolve(fetchSelect(endpointUrl, authToken, inputValue, { location: null, noAvailability: noAvailability ? true : false, isAccount }))
        });
    };

    useEffect(async () => {
        if (isDefaultValueFromApi) {
            const loadOp = await loadOptions("");
            setDefaultValueFromApi(loadOp[0]);
        }
    }, [])

    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const onClickCreateButton = (e) => {
        e.preventDefault();
        setIsDropdownOpen(false);
        setModalTriggerName(nameSection)
        setModalShow(createNew.modalName);
    };

    useEffect(() => {
        if (!formEdit && Object.keys(defaultData).length && !defaultData.error) {
            setValue(name, defaultData)
        } else if (!formEdit) {
            setValue(name, defaultValue)
        }
    }, [defaultData])

    return (
        <div className='select-field'>
            {
                label &&
                <label
                    className="select-field__label">
                    {label}
                    {
                        validationProps ?
                            validationProps.required ? <span className="form-field__label__required"> * </span> :
                                null :
                            null
                    }
                </label>
            }

            <Controller
                control={control}
                {...register(name, validationProps)}
                ref={null}
                defaultValue={defaultData.length ? defaultData : defaultValue}
                render={({
                    field: { onChange, onBlur, value, name, ref },
                }) => {
                    return (
                        <AsyncSelect
                            className={`select-field__select ${errors[fieldName]?.[partNumber]?.[fieldItemName] && 'select-field__select--error'}`}
                            styles={customStyles}
                            defaultOptions={true}
                            cacheOptions={true}
                            value={value ? value : defaultValueFromApi}
                            onChange={(value) => {
                                onChange(value);
                                valueEntered();
                            }}
                            loadOptions={loadOptions}
                            isMulti={mutliselect}
                            menuPlacement="auto"
                            menuPortalTarget={document.body}
                            isDisabled={disabled}
                            isSearchable={isSearchable}
                            onBlur={(event) => {
                                valueEntered();
                            }}
                            autoComplete="new-password"
                            menuIsOpen={isDropdownOpen}
                            onMenuOpen={() => setIsDropdownOpen(true)}
                            onMenuClose={() => setIsDropdownOpen(false)}
                            components={createNew ? { MenuList: (props) => <CustomMenuList {...props} createNew={createNew} onClickCreateButton={onClickCreateButton} /> } : null}
                        />
                    )
                }}
            />
            {errors?.[fieldName]?.[partNumber]?.[fieldItemName] && <FormFieldError errorMessage={errors?.[fieldName]?.[partNumber]?.[fieldItemName].message} />
            }
        </div >
    )
};

const mapStateToProps = createStructuredSelector({
    formEdit: selectFormEdit,
    formLatestData: selectFormTableLatestData,
});

const mapDispatchToProps = dispatch => ({
    setValueEntredBlur: (data) =>
        dispatch(setValueEntredBlur(data)),
    setModalShow: (data) =>
        dispatch(setModalShow(data)),
    setModalTriggerName: (data) =>
        dispatch(setModalTriggerName(data)),
})

export default connect(mapStateToProps, mapDispatchToProps)(SelectField);
